import { cn } from '@/custolink-newdesign/lib/utils';

/**
 * Token + type-scale boundary for shadcn/ui primitives living inside the MUI app.
 *
 * Every shadcn primitive MUST render inside this element. Outside it the design
 * tokens are undefined (so colour utilities fall back to their initial value) and
 * the type ramp is the app's rescaled one (text-sm = 11px, not 14px). See the
 * header comment in src/styles/shadcn.css for why the tokens are scoped rather
 * than declared on :root.
 *
 * Radix portals render outside this DOM subtree, so a portalled primitive
 * (Dialog, Sheet, AlertDialog, Select, Popover, Tooltip, DropdownMenu -- all of
 * them are in use today) would lose the tokens. shadcn.css handles that by
 * repeating the token block on each portal surface's `data-slot` selector; a new
 * portalled primitive must be added to those selector lists, or it renders
 * untokenised.
 *
 * That block is unlayered, so anything it declares BEATS a Tailwind utility in
 * @layer utilities. Tokens are safe (nothing else declares them), but a plain
 * property there silently outranks the utility a component wrote on itself --
 * which is why the base text colour lives in @layer components instead. See the
 * comment on that rule before adding another non-token declaration.
 */
export function ShadcnScope({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-shadcn-scope=""
			className={cn('shadcn-scope', className)}
			{...props}
		/>
	);
}

export default ShadcnScope;
